<div class="w-full h-full flex flex-col">
	<div class="flex justify-between items-center gap-2 mb-2">
		<atomic-button-dropdown
			#fileDd
			btn="none"
			size="large"
			[itemGroups]="itemGroups"
			[showOptionsBorder]="false"
			[show]="showDropdown"
			(showing)="fileDropdownShowing$.next($event)"
			(onSelect)="onSelect($event)"
			(click)="toggleDropdown()"
			[testHook]="testHooks.FileDdButtonDropdown"
		>
			<p class="max-w-250 truncate mr-2">{{ selectedDocument?.name }}</p>
			<p class="mr-2">({{ documents?.length }})</p>
			<app-icon
				[icon]="(fileDropdownShowing$ | async) ? ICON.UP : ICON.DOWN"
				[testHook]="testHooks.DownIcon"
			></app-icon>
		</atomic-button-dropdown>
		<div>
			<atomic-kebab-options
				[itemGroups]="[{ items: SelectedDocumentKebabOptions }]"
				(onSelect)="onKebabSelect(selectedDocument, $event.result)"
				[testHook]="testHooks.KebabOptions"
			></atomic-kebab-options>
		</div>
	</div>
	<div class="flex-1">
		<app-matter-url-pdf-viewer
			class="overflow-hidden"
			[showMultiple]="true"
			[googleSrcUrl]="selectedDocument?.url"
			[fileName]="selectedDocument?.name"
			[fileType]="selectedDocument?.fileType"
			[highlightFields]="highlightFields"
			[scrollToFieldName]="scrollToFieldName"
		></app-matter-url-pdf-viewer>
	</div>
</div>

<ng-template #documentTemplate let-item>
	<div class="text-sm">
		<p class="whitespace-nowrap max-w-250 truncate">{{ item?.name }}</p>
		<p class="text-grey-light whitespace-nowrap">
			Uploaded: {{ item?.uploadedAt | date: "MMM d, y, 'at' h:mm a" }}
		</p>
	</div>
</ng-template>
